import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { useSession } from '@/shared/auth';
import { useI18n } from '@/shared/i18n/useT';
import { PageHeader } from '@/shared/components/PageHeader';

export function InviteAcceptancePage() {
  const { token = '' } = useParams();
  const { status } = useSession();
  const { t } = useI18n();
  const navigate = useNavigate();
  const [state, setState] = useState<'loading' | 'accepted' | 'error'>('loading');

  useEffect(() => {
    if (status === 'signedOut') {
      navigate(`/signin?next=${encodeURIComponent(`/invite/${token}`)}`, { replace: true });
      return;
    }
    if (status !== 'signedIn' || !token) return;
    void (async () => {
      const { data } = await supabase.auth.getSession();
      const response = await fetch('/api/invitations/accept', {
        method: 'POST',
        headers: { Authorization: `Bearer ${data.session?.access_token ?? ''}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ token }),
      });
      setState(response.ok ? 'accepted' : 'error');
    })();
  }, [navigate, status, token]);

  if (state === 'accepted') {
    return <div className="py-6 sm:py-8"><PageHeader title={t('invitation.acceptedTitle')} description={t('invitation.acceptedBody')} actions={<button type="button" className="tap-target rounded-full bg-accent px-4 text-accent-fg" onClick={() => navigate('/')}>{t('common.goHome')}</button>} /></div>;
  }
  if (state === 'error') return <div className="py-6 sm:py-8"><PageHeader title={t('invitation.errorTitle')} description={t('invitation.errorBody')} actions={<button type="button" className="tap-target rounded-full bg-accent px-4 text-accent-fg" onClick={() => navigate('/')}>{t('common.goHome')}</button>} /></div>;
  return <div className="py-6 sm:py-8"><PageHeader title={t('invitation.loadingTitle')} description={t('common.loading')} /></div>;
}
